import React from 'react';
import { DefaultEditor } from 'react-simple-wysiwyg';
import InputWrapper from './InputWrapper';

const InputHtmlEditor = ({ value, onChange, placeholder, label, error, name }) => {
  return (
    <InputWrapper label={label} error={error}>
      <DefaultEditor
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        name={name}
        style={{ minHeight: '320px' }}
      />
    </InputWrapper>
  );
};

export default InputHtmlEditor;
